var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Download"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download",
    clipPath: "url(#clip-Download)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_dowload",
    "data-name": "icon dowload",
    d: "M1307.511,557.109v-3.434a.645.645,0,0,1,.615-.67.638.638,0,0,1,.633.585l.006.086v3.434h3.893a3.783,3.783,0,0,1,3.625,3.751v4.5a3.807,3.807,0,0,1-3.447,3.919h-9.227a3.77,3.77,0,0,1-3.616-3.751v-4.493a3.809,3.809,0,0,1,3.439-3.92l.17,0h3.91V562.6l-1.3-1.417a.594.594,0,0,0-.869-.019l-.018.019a.744.744,0,0,0-.065.88l.065.086,2.37,2.583a.586.586,0,0,0,.827.061l.061-.061,2.37-2.583a.725.725,0,0,0,0-.965.593.593,0,0,0-.814-.066l-.07.066-1.3,1.415v-5.483Z",
    transform: "translate(-1298.138 -551.143)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.ff437504e46420621c57270763245839.svg";
export { ForwardRef as ReactComponent };